var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shuffle-svgrepo-com 1",
    clipPath: "url(#clip0_547_2102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6002 5.1959C12.4175 5.1959 12.2779 5.34631 12.2779 5.5182V11.3197C12.2779 11.685 11.9878 11.9751 11.6225 11.9751H1.8029C1.43762 11.9751 1.14754 11.685 1.14754 11.3197V1.85466C1.14754 1.48938 1.43762 1.1993 1.8029 1.1993H8.1201C8.30274 1.1993 8.44241 1.04889 8.44241 0.876994C8.44241 0.694354 8.292 0.554688 8.1201 0.554688H1.73844C1.05085 0.554688 0.492188 1.11335 0.492188 1.80094V11.4057C0.492188 12.0932 1.05085 12.6519 1.73844 12.6519H11.687C12.3745 12.6519 12.9332 12.0932 12.9332 11.4057V5.5182C12.9332 5.34631 12.7828 5.1959 12.6002 5.1959Z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.664 1.74653L12.0731 1.15564C11.6648 0.747385 11.0202 0.70441 10.6549 1.08043L4.4344 7.30094L6.51865 9.38519L12.7392 3.16468C13.1152 2.7994 13.0829 2.15479 12.664 1.74653ZM11.0954 3.8845L6.47567 8.50422L5.31537 7.35466L9.95658 2.71345L11.0954 3.8845ZM12.2772 2.70271L11.5896 3.3903L10.44 2.22999L11.1169 1.55315C11.2565 1.41348 11.5036 1.42423 11.6541 1.58538L12.245 2.17628C12.4061 2.31594 12.4169 2.56304 12.2772 2.70271ZM4.4344 7.32243L3.78979 9.66452C3.75756 9.77196 3.78979 9.87939 3.86499 9.9546C3.9402 10.0298 4.04763 10.062 4.15507 10.0298L6.49716 9.38519L6.0137 8.90173L4.49886 9.32073L4.91786 7.79515L4.4344 7.32243Z",
    fill: "#767676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_2102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.44,
    height: 13.44,
    fill: "white",
    transform: "translate(0 0.279297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestFeedback);
export default __webpack_public_path__ + "static/media/testFeedback.1e9ac3bdcad425ac9ad454a0af6bb3c0.svg";
export { ForwardRef as ReactComponent };